import { coreTranslations } from '@sentinel/web-core';
import console from './console.json';

/** English. Keys are `module.context.key`. */
const en = { ...coreTranslations.en, console };
export default en;
